import View from 'view/view'
import dataProvider from 'service/data_provider'

import ModalView from 'component/modal/modal'
import Router from 'service/router'
import locationService from 'service/location'
import stickyFlashMessage from 'shared/view/sticky_flash_message'

const FeedbackView = View.extend({
    events: {
        click: '_showFeedbackModal',
    },

    initialize(options) {
        this.options = options
        this._checkFeedbackModal()
    },

    _showFeedbackModal() {
        const modalUrl =
            this.options.entityType === 'event'
                ? Router.path('event_feedback_event_modal_get', { eventId: this.options.entityId })
                : Router.path('event_feedback_activity_modal_get', { activityId: this.options.entityId })

        this.initSubview(ModalView, {
            name: 'Feedback',
            classes: 't-modal modal',
            url: modalUrl,
            fullHeight: true,
            // Postpone opening the modal until the Modal:opened handler is set below
            initializeOnly: true,
        })
            .once('Modal:opened', this._onFeedbackModalOpen, this)
            .open()
    },

    _onFeedbackModalOpen(payload) {
        require.ensure([], (require) => {
            const FeedbackModalView = require('bundle/event_feedback/view/modal').default

            this.initSubview(FeedbackModalView, {
                el: payload.container,
                entityType: this.options.entityType,
            })
        })
    },

    _checkFeedbackModal() {
        if (dataProvider.get('forceFeedbackModal')) {
            this._showFeedbackModal()
            return
        }

        if (locationService.getHash() !== 'feedback') {
            return
        }

        if (!dataProvider.get('isEligibleForFeedback')) {
            if (dataProvider.get('feedbackIneligibilityReason')) {
                stickyFlashMessage.show(dataProvider.get('feedbackIneligibilityReason'), { type: 'error' })
            }
            return
        }

        this._showFeedbackModal()
    },
})

export default FeedbackView
